@if (visible()) {
  <button
    mat-icon-button
    type="button"
    matTooltip="Install Pharvios on this device"
    aria-label="Install Pharvios on this device"
    (click)="install()">
    <mat-icon [svgIcon]="icon"></mat-icon>
  </button>
}
